// SelectedEmpPDFView.jsx
import React from "react";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";

const SelectedEmpPDFView = React.forwardRef(({ employee, salonInfo }, ref) => {
    return (
        <Box
            ref={ref}
            sx={{
                p: 4,
                fontFamily: "Arial",
                width: "100%",
                color: "#000",
                backgroundColor: "#fff",
            }}
        >
            {/* Header */}
            <Box textAlign="center" mb={4}>
                <Typography variant="h4" sx={{ color: "#002366", fontWeight: "bold" }}>
                    {salonInfo?.name}
                </Typography>
                <Typography sx={{ fontWeight: "bold", color: "#002366" }}>{salonInfo?.address}</Typography>
                <Typography sx={{ fontWeight: "bold", color: "#002366" }}>
                    PH-NO : {salonInfo?.phone}
                </Typography>
                <Typography sx={{ fontWeight: "bold", color: "#002366" }}>
                    Email : {salonInfo?.email || "Palacethesalon@gmail.com"}
                </Typography>
            </Box>

            {/* Employee Profile */}
            <Box sx={{mb : 2}}>
                <Typography variant="subtitle1"
                    sx={{ fontWeight: "bold", color: "#002366", textAlign: "center" }}>
                    {employee?.employeeName || "N/A"}
                </Typography>
                <Typography variant="body2"
                    sx={{ mt: 1, fontWeight: "bold", fontStyle: "italic", textAlign: "center" }}>
                    {employee?.designation || "N/A"}
                </Typography>
            </Box>
            {/* <Table>
                <TableBody> */}
            {/* <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
            <TableCell>{employee?.employeeName || "N/A"}</TableCell>
          </TableRow> */}
            {/* <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Designation</TableCell>
            <TableCell>{employee?.designation || "N/A"}</TableCell>
          </TableRow> */}
            {/* <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Mobile</TableCell>
            <TableCell>{employee?.mobileNumber || "N/A"}</TableCell>
          </TableRow> */}
            {/* <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
            <TableCell>{employee?.email || "N/A"}</TableCell>
          </TableRow> */}
            {/* <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Skills</TableCell>
            <TableCell>{employee?.skillSet || "N/A"}</TableCell>
          </TableRow> */}
            <Box sx={{ mt: 4 }}>
                <Typography variant="subtitle1"
                    sx={{ fontWeight: "bold", color: "#002366" }}>Specialization</Typography>
                <Typography variant="body2"
                    sx={{ mt: 1, fontWeight: "bold", fontStyle: "italic" }}>{employee?.specialization || "N/A"}</Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle1"
                    sx={{ fontWeight: "bold", color: "#002366" }}>Achievements</Typography>
                <Typography variant="body2"
                    sx={{ mt: 1, fontWeight: "bold", fontStyle: "italic" }}>{employee?.achievements || "N/A"}</Typography>
            </Box>
            <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle1"
                    sx={{ fontWeight: "bold", color: "#002366" }}>Overview</Typography>
                <Typography variant="body2"
                    sx={{ mt: 1, fontWeight: "bold", fontStyle: "italic" }}>{employee?.overview || "N/A"}</Typography>
            </Box>
            {/* </TableBody>
            </Table> */}
        </Box>
    );
});

export default SelectedEmpPDFView;
